import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
function RoomsByDepartment() {
    const navigate = useNavigate();
    useEffect(() => {
        const scriptUrls = [
            '/assets/js/jquery.min.js',
            '/assets/js/bootstrap.bundle.min.js',
            '/assets/js/moment.min.js',
            '/assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
            '/assets/vendor/overlay-scroll/custom-scrollbar.js',
            '/assets/vendor/daterange/daterange.js',
            '/assets/vendor/daterange/custom-daterange.js',
            '/assets/vendor/jquery-ui/jquery-ui.min.js',
            '/assets/vendor/jquery-ui/custom.js',
            '/assets/vendor/datatables/dataTables.min.js',
            '/assets/vendor/datatables/dataTables.bootstrap.min.js',
            '/assets/vendor/datatables/custom/custom-datatables.js',
            '/assets/js/custom.js',


        ];

        let isCancelled = false;

        const loadScriptsSequentially = async () => {
            for (const url of scriptUrls) {
                if (isCancelled) break;

                await new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = url;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.body.appendChild(script);
                });
            }
        };

        loadScriptsSequentially();

        return () => {
            isCancelled = true;
        };
    }, []);
    const handleSubmit = () => {
        // Optional: Add form validation logic here
        navigate("/available-rooms");
        setTimeout(() => {
            window.location.reload(); // force page refresh after navigation
        }, 100);
    };
    return (<>


        <div className="app-container">
            {/* App header starts */}
            {/* Search container starts */}
            {/* App header ends */}
            {/* App hero header starts */}
            <div className="app-hero-header d-flex align-items-center">
                {/* Breadcrumb starts */}
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a href="index-2.html">
                            <i className="ri-home-3-line" />
                        </a>
                    </li>
                    <li className="breadcrumb-item">Rooms</li>
                    <li className="breadcrumb-item text-primary" aria-current="page">
                        Rooms By Department
                    </li>
                </ol>
                {/* Breadcrumb ends */}
                {/* Sales stats starts */}
                <div className="ms-auto d-lg-flex d-none flex-row">
                    <div className="input-group">
                        <span className="input-group-text bg-primary-lighten">
                            <i className="ri-calendar-2-line text-primary" />
                        </span>
                        <input type="text" id="abc" className="form-control custom-daterange" />
                    </div>
                </div>
                {/* Sales stats ends */}
            </div>
            {/* App Hero header ends */}
            {/* App body starts */}
            <div className="app-body">
                {/* Row starts */}
                <div className="row gx-4">
                    <div className="col-sm-12">
                        <div className="card mb-4">
                            <div className="card-header">
                                <h5 className="card-title">Rooms by Department</h5>
                            </div>
                            <div className="card-body">
                                {/* Table starts */}
                                <div className="table-outer">
                                    <div className="table-responsive">
                                        <table className="table truncate align-middle m-0">
                                            <thead>
                                                <tr>
                                                    <th width="60px">&nbsp;</th>
                                                    <th width="100px">Department</th>
                                                    <th width="100px">Total</th>
                                                    <th width="100px">Occupied</th>
                                                    <th width="100px">Reserved</th>
                                                    <th width="100px">Available</th>
                                                    <th width="100px">Cleanup</th>
                                                    <th width="100px">Other</th>
                                                    <th width="100px">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[
                                                    {
                                                        img: "assets/images/products/1.jpg",
                                                        dept: "Cardiology",
                                                        stats: [25, 9, 3, 7, 2, 4],
                                                    },
                                                    {
                                                        img: "assets/images/products/3.jpg",
                                                        dept: "Orthopedics",
                                                        stats: [21, 6, 5, 2, 5, 3],
                                                    },
                                                    {
                                                        img: "assets/images/products/4.jpg",
                                                        dept: "Neurology",
                                                        stats: [15, 2, 4, 3, 4, 2],
                                                    },
                                                    {
                                                        img: "assets/images/products/6.jpg",
                                                        dept: "Gastroenterology",
                                                        stats: [19, 1, 5, 3, 3, 7],
                                                    },
                                                    {
                                                        img: "assets/images/products/2.jpg",
                                                        dept: "Anatomy",
                                                        stats: [13, 2, 2, 1, 5, 3],
                                                    },
                                                ].map((row, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <img
                                                                src={row.img}
                                                                alt="Department"
                                                                className="rounded-2 img-3x"
                                                            />
                                                        </td>
                                                        <td>{row.dept}</td>
                                                        <td>
                                                            <span className="badge bg-primary text-white rounded px-2 small">
                                                                {row.stats[0]}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="badge border border-primary text-primary rounded px-2 small">
                                                                <i className="ri-circle-fill" /> {row.stats[1]}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="badge border border-danger text-danger rounded px-2 small">
                                                                <i className="ri-circle-fill" /> {row.stats[2]}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="badge border border-info text-info rounded px-2 small">
                                                                <i className="ri-circle-fill" /> {row.stats[3]}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="badge border border-warning text-warning rounded px-2 small">
                                                                <i className="ri-circle-fill" /> {row.stats[4]}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="badge border border-secondary text-dark rounded px-2 small">
                                                                <i className="ri-circle-fill" /> {row.stats[5]}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-primary"
                                                                onClick={handleSubmit}
                                                            >
                                                                View Rooms
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {/* Table ends */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Row ends */}
            </div>
            {/* App body ends */}
            {/* App footer starts */}

            {/* App footer ends */}
        </div>
        {/* App container ends */}

    </>)

}
export default RoomsByDepartment;
